module.exports = __webpack_public_path__ + "temo-api-icon.png?0a045523d7a39769d2059dd4345844e2";